module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_chapel-91d914e5c9fa8d58e688afc3179e41ed.jpg";